import { A11yModule } from '@angular/cdk/a11y';
import { NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FollowCard } from '@shared/models/preferences';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';
import { Angulartics2Segment } from 'angulartics2';
import { ArtistCardComponent } from '../artist-card/artist-card.component';
import { InterestCardComponent } from '../interest-card/interest-card.component';

export enum ButtonName {
  Discover_More = 'Discover',
}

@Component({
  selector: 'ten-preferences-popup',
  templateUrl: './preferences-popup.component.html',
  styleUrls: ['./preferences-popup.component.scss'],
  providers: [TranslatePipe],
  standalone: true,
  imports: [
    A11yModule,
    TranslateModule,
    NgIf,
    ArtistCardComponent,
    NgFor,
    InterestCardComponent,
    MatLegacyButtonModule,
    AccessibleClickDirective,
    MatIconModule,
    MatDialogModule,
  ],
})
export class PreferencesPopupComponent {
  public isPreferencesPopup: boolean;
  public isInterestsPreferences: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public cards: FollowCard[],
    private router: Router,
    private angulartics2Segment: Angulartics2Segment,
    private translate: TranslatePipe,
    private materialDialog: MatDialog,
    private matDialogRef: MatDialogRef<PreferencesPopupComponent>
  ) {}

  public onSkipClick(): void {
    const eventLabel = `Pop-up - ${this.translate.transform(this.skipLabel)} button`;

    this.angulartics2Segment.eventTrack(eventLabel, {
      ButtonName: this.translate.transform(this.skipLabel),
    });
  }

  public onDiscoverMoreClick(): void {
    const eventLabel = this.discoverMoreLabel;

    this.angulartics2Segment.eventTrack(eventLabel, {
      ButtonName: this.translate.transform('Preferences:DiscoverMore'),
    });

    const route =
      this.isPreferencesPopup && this.isInterestsPreferences
        ? ['/preferences/follow-interests']
        : ['/preferences/follow-artists'];
    this.router.navigate(route);

    this.materialDialog?.getDialogById('top-interest-popup')?.close(ButtonName.Discover_More);
  }

  public onCloseClick(): void {
    const eventLabel = 'Pop-up - Close button';

    this.angulartics2Segment.eventTrack(eventLabel, {
      ButtonName: 'X close button',
    });

    this.matDialogRef.close();
  }

  private get skipLabel(): string {
    return this.isPreferencesPopup ? 'Preferences:Skip' : 'Preferences:Close';
  }

  private get discoverMoreLabel(): string {
    return this.isPreferencesPopup
      ? 'Pop-up - Discover more button'
      : 'Preferences_Discover more home page pop up clicked';
  }
}
